import client from '../../api';

export const getConsensusSummaryApi = (id, status) => client.get(`strapi/consensus-summaries/${id}/${status}`);

export const postConsensusSummaryApi = consensusSummary => client.post('strapi', { data: consensusSummary });

export const getPeerChallengeApi = (id, status) => client.get(`strapi/peer-challenges/${id}/${status}`);
